"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginRoute = void 0;
var React = __importStar(require("react"));
var loading_part_1 = require("../parts/loading.part");
var use_active_person_1 = require("../../../hooks/use-active-person");
var router_1 = require("@reach/router");
var lodash_1 = require("lodash");
var LoginRoute = function (props) {
  var person = (0, use_active_person_1.useActivePerson)().person;
  React.useEffect(function () {
    if (person) {
      var landingPath = person && person.defaultPath || '';
      (0, router_1.navigate)("/".concat((0, lodash_1.trim)(landingPath, '/')));
    }
  });
  return React.createElement(loading_part_1.LoadingPart, null);
};
exports.LoginRoute = LoginRoute;
exports.default = exports.LoginRoute;